import styled from "styled-components"

export type BadgeVariant = "failed" | "approval"

export const Badge = styled.span<{ $variant: BadgeVariant }>`
  background: ${(p) =>
    p.$variant === "approval" ? p.theme.colors.orange : p.theme.colors.error.background};
  color: ${(p) => p.theme.colors.white};
  font-size: 1rem;
  font-weight: 700;
  min-width: 2rem;
  height: 2rem;
  border-radius: 1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;
  margin-left: auto;
  flex-shrink: 0;
`

export const BadgeGroup = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-left: auto;
  flex-shrink: 0;

  ${Badge} {
    margin-left: 0;
  }
`
